module.exports = __webpack_public_path__ + "img/bime-dey.4a8e9f8.png";